import { createNamespacedHelpers } from "vuex";
import { GameStatus } from '@utils/game/sheep/types.js';
import { GAME_CONFIG, getLevelConfig, ADV_ROUND } from '@utils/game/sheep/constants.js';
import { generateLevel, updateClickableStatus } from '@utils/game/sheep/gameLogic.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "sheepPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    nextBtnText() {
      return (this.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    }
  },
  data() {
    return {
      popStartShow: false,
      popWinShow: false,
      popLostShow: false,
      advList: [],
      deckTiles: [],
      slotTiles: [],
      status: GameStatus.idle,
      revives: GAME_CONFIG.maxRevives,
      lastScore: 0,
      score: 0,
      level: 1,
      processingTiles: new Set(),
      prizePool: 0,
      leftTime: 0,
      timePeriod: "",
      maxRevives: GAME_CONFIG.maxRevives,
      stimeVal: null,
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popOpenMobileShow: false,
      timeVal: null,
      isClickAdv: false
    };
  },
  watch: {
    // 监控 slotTiles 或 status 变化
    slotTiles: {
      handler() {
        this.checkMatching();
        this.checkWinCondition();
      },
      deep: true
    },
    status() {
      this.checkMatching();
      this.checkWinCondition();
      setTimeout(() => {
        this.popWinShow = this.status === 'won';
        this.popLostShow = this.status === 'lost';
        this.popStartShow = this.status === 'idle';
      }, 100);
    },
    deckTiles: {
      handler() {
        this.checkWinCondition();
      },
      deep: true
    },
    score: {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          console.log('score', this.score);
          this.end();
        }, 200);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.stimeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    // 初始化游戏 / 开始新关卡
    // restartCurrentLevel: true 表示重玩当前关，false 表示进入指定 level
    async startGame(targetLevel) {
      await this.start();
      const config = getLevelConfig(targetLevel);
      const newTiles = generateLevel(config);
      this.deckTiles = newTiles;
      this.slotTiles = [];
      this.status = GameStatus.playing;
      this.level = targetLevel;
      this.processingTiles.clear(); // 清除处理锁

      // 注意：分数通常在通关时累积，重玩当前关是否重置分数取决于设计。
      // 这里我们选择如果回到第一关则重置分数，否则保留。
      if (targetLevel === 1) {
        this.revives = GAME_CONFIG.maxRevives;
        this.score = 0;
      }
    },
    checkMatching() {
      if (this.status !== "playing") return;
      const counts = {};
      this.slotTiles.forEach(t => {
        counts[t.type] = (counts[t.type] || 0) + 1;
      });
      const typeToRemove = Object.keys(counts).find(key => counts[key] >= 3);
      if (typeToRemove) {
        //setTimeout(() => {
        this.slotTiles = this.slotTiles.filter(t => t.type !== typeToRemove);
        this.score += 3;
        //}, 200);
      } else {
        // 游戏失败
        if (this.slotTiles.length >= GAME_CONFIG.maxSlots) {
          this.status = "lost";
        }
      }
    },
    // React useEffect #2：检测胜利逻辑
    checkWinCondition() {
      if (this.status === "playing" && this.deckTiles.length === 0 && this.slotTiles.length === 0) {
        this.status = "won";
        this.end();
      }
    },
    handleTileClick(clickedTile) {
      if (this.status !== 'playing') return;
      if (!clickedTile.isClickable) return;

      // 防止重复点击同一个方块（双击BUG修复）
      if (this.processingTiles.has(clickedTile.id)) return;

      // 严格检查槽位限制
      if (this.slotTiles.length >= GAME_CONFIG.maxSlots) return;

      // 锁定该方块，防止在 React 渲染前被再次点击
      this.processingTiles.add(clickedTile.id);

      // 1. 从牌堆移除当前点击的方块
      let remaining = this.deckTiles.filter(t => t.id !== clickedTile.id);

      // 2. 更新可点击状态
      remaining = updateClickableStatus(remaining);

      // 3. 更新 deckTiles
      this.deckTiles = remaining;

      // 4. 添加到槽位末尾
      this.slotTiles = [...this.slotTiles, clickedTile];
    },
    // 移出/复活逻辑：将槽位中的前3张牌放回牌堆
    handleMoveOutTiles(reduced = false) {
      // if(this.isClickAdv) return;
      // this.isClickAdv = true
      if (reduced && this.revives <= 0) return;
      // 检查条件：必须有剩余次数，且槽位里有牌
      //if (this.revives <= 0 || this.slotTiles.length === 0) return;
      if (this.slotTiles.length === 0) return;
      const callback = res => {
        this.isClickAdv = false;
        if (res && res.code == 0) {
          this.prizePool = res.data.keys;
        }
        const count = Math.min(3, this.slotTiles.length);
        const tilesToMove = this.slotTiles.slice(0, count);
        const remainingSlotTiles = this.slotTiles.slice(count);

        // 1. 关键修复：解锁这些方块的点击状态
        // 因为之前点击时加入到了 processingTiles 中，如果不移除，放回去也点不动
        tilesToMove.forEach(t => this.processingTiles.delete(t.id));

        //2. 将方块放回牌堆
        // 计算最大的 zIndex
        let maxZ = 0;
        if (this.deckTiles.length > 0) {
          maxZ = Math.max(...this.deckTiles.map(t => t.zIndex));
        }

        // 生成新的返回方块
        const returnedTiles = tilesToMove.map((tile, index) => ({
          ...tile,
          x: Math.random() * 4 - 2,
          y: Math.random() * 4 - 2,
          layer: 100,
          zIndex: maxZ + 1 + index,
          isClickable: true
        }));

        // 合并回牌堆
        let newDeck = [...this.deckTiles, ...returnedTiles];

        // 按 zIndex 排序
        newDeck.sort((a, b) => a.zIndex - b.zIndex);

        // 更新可点击状态
        newDeck = updateClickableStatus(newDeck);

        // 更新 deckTiles
        this.deckTiles = newDeck;

        // 更新槽位
        this.slotTiles = remainingSlotTiles;

        // 扣减复活次数
        if (reduced) {
          this.revives = this.revives - 1 >= 0 ? this.revives - 1 : 0;
        }

        // 如果是从失败界面调用的（复活），恢复游戏状态为进行中
        if (this.status === 'lost') {
          this.status = 'playing';
        }
      };
      let advData = getRandomElement(this.advList);
      if (advData) {
        gameAdv.show(advData, this.timePeriod, res => {
          callback(res);
        }, this);
      } else {
        callback(null);
      }
    },
    handleNextLevel() {
      const callback = res => {
        this.popWinShow = false;
        this.startGame(this.level + 1);
      };
      if ((this.level + 1) % ADV_ROUND === 0) {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } else {
        callback(null);
      }
    },
    handleRetry() {
      //this.startGame(this.level); // 重试当前关卡
      this.startGame(1); // 重试当前关卡
    },

    handleRestartGame() {
      this.startGame(1); // 回到第一关
    },

    handleCancel() {
      //this.revives > 0 ? this.handleRetry() : this.handleRestartGame()
      this.handleRetry();
    },
    handleConfirm() {
      this.revives > 0 ? this.handleMoveOutTiles(true) : this.handleRetry();
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "sheep"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
        this.countDown();
      });
    },
    async end() {
      if (this.lastScore >= this.score) return;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "sheep",
        level: this.level,
        score: this.score,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "sheep"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(() => {
        if (this.leftTime <= 0) {
          this.status = 'idle';
          this.deckTiles = [];
          this.slotTiles = [];
          this.init();
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.popGameRankShow = true;
      });
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "sheep"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    if (this.status == GameStatus.idle) {
      this.popStartShow = true;
    }
  }
};